export const lightTheme = {
  green100: '#D2F5E4',
  green200: '#43B97F',
  green300: '#2D7B57',
  blue100: '#DEF3F7',
  blue200: '#7CCEE0',
  blue300: '#057992',
  yellow100: '#FFF0CB',
  yellow200: '#F9D357',
  yellow300: '#7D391C',
  red100: '#F96157',
};

export const tabs = (salary?: string) => ({
  title: 'Reasons to love Terminal',
  sections: [
    {
      button: 'Compensation',
      image: '/images/light-lp/tabs/compensation.png',
      roles: [
        {
          icon: '/images/light-lp/tabs/calendly.png',
          company: 'Calendly',
          role: 'Frontend Engineer',
          salary,
          showSalary: !!salary,
        },
      ],
      title: 'Industry Leading Compensation & Benefits',
      text: 'At Silicon Valley’s best-kept secret, we value transparency. It’s no secret engineers want to earn what they’re worth. At Terminal, we reward engineers with top salaries.',
      list: ['high-paying jobs', 'full-time benefits', 'leadership roles and equity'],
      italic: 'Let Terminal show you why we are Silicon Valley’s best-kept secret today.',
    },
    {
      button: 'Challenging Roles',
      image: '/images/light-lp/tabs/challenging-roles.png',
      roles: [
        {
          icon: '/images/light-lp/animation/earnin.jpg',
          company: 'Earnin',
          role: 'Frontend Engineer',
          salary,
          showSalary: !!salary,
        },
        {
          icon: '/images/light-lp/animation/calendly-grey.jpg',
          company: 'Calendly',
          role: 'Frontend Engineer',
          salary,
          showSalary: !!salary,
        },
        {
          icon: '/images/light-lp/animation/nextdoor.jpg',
          company: 'Nextdoor',
          role: 'Frontend Engineer',
          salary,
          showSalary: !!salary,
        },
      ],
      title: 'Time to Level-Up',
      text: 'Fast growing start-ups rely on Terminal to find the best engineering talent around the globe. That’s the truth. Stop struggling to connect with these companies and get an insider’s help. We have the best access to challenging, remote roles at companies like hims & hers, Doordash, everlywell, Handshake & more.',
      list: [],
      italic: 'Are you ready to level-up your career?',
    },
    {
      button: 'Fulltime/Remote',
      image: '/images/light-lp/tabs/fulltime-remote.png',
      roles: [],
      title: 'Work from your comfort zone',
      text: 'Enough of the short-term contracts and part-time roles. Terminal focuses exclusively on remote roles with our clients. You feel like you work directly for them, because you do. We just handle the HR details on our end of things. Did we mention you don’t have to move? That’s right, this is full-remote.',
      list: [],
      italic: 'Working from home has never felt better.',
    },
  ],
});

export const successStory = {
  name: 'Jesús Estrada',
  title: 'Tech Lead at Handshake via Terminal Colombia',
  text: '“Terminal has changed my life. I have grown professionally and it gives me the chance to maintain a direct relationship with the client. The dynamic with full-time is different. You become part of a company”',
  image: '/images/light-lp/people/jesus-estrada.png',
};

export const skillsOptions = [
  '.NET',
  'Angular',
  'AWS',
  'C/C++',
  'Django',
  'Docker',
  'Go',
  'Java',
  'Javascript',
  'MySQL',
  'Node',
  'NoSQL',
  'Python',
  'React',
  'Ruby',
  'Typescript',
];

export const faq = [
  {
    q: 'Is Terminal a recruiting agency?',
    a: 'No! We work with our partner-companies to recruit engineers for their teams, but we also remain your legal employer in your home country - This allows US companies to hire developers outside of the US, while also offering developers the flexibility of 100% remote work in either full-time or contract roles.',
  },
  {
    q: 'Who will I work for?',
    a: 'You will be employed by Terminal in your country of residence, but your work will be 100% dedicated to the partner-company you’re hired by. While you will be embedded in an engineering team with the startup that you’ve accepted a role with,Terminal handles all of your contracts and benefits.',
  },
  {
    q: 'What countries do you hire from?',
    a: 'We currently hire talent from Costa Rica, Canada, Mexico, Colombia, Chile, Poland & Spain. You will only be matched with roles that are available in your country of residence.',
  },
  {
    q: 'Will I be working as a contractor?',
    a: 'You decide whether you are open to taking contract roles, full-time roles, or both. Contract roles are fully supported by Terminal and frequently offer contract-to-hire paths. Full-time roles receive the benefits that come along with that status in your home country, such as country-specific holidays and severance requirements. These laws and benefits vary from country to country.',
  },
];

export const jobs = (salary?: string) => [
  {
    icon: '/images/light-lp/icons/stack.svg',
    title: 'Fullstack Developer',
    industry: 'Business Services',
    techStack: ['Python', 'HTML/CSS', 'Java', 'React'],
    salary: salary,
    description:
      'You’ll join a highly collaborative and cross-functional team working to take new features from concept to production...',
    color: '#2D7B57',
    bgColor: '#D2F5E4',
  },
  {
    icon: '/images/light-lp/icons/cogs.svg',
    title: 'Senior Python Developer',
    industry: 'Software',
    techStack: ['Python', 'C#', 'NoSQL', 'MySQL'],
    salary: salary,
    description:
      'You will build large scale machine learning infrastructure, solve challenging problems with cutting edge design and algorithms...',
    color: '#25383F',
    bgColor: '#F4F7F9',
  },
  {
    icon: '/images/light-lp/icons/code-bracket.svg',
    title: 'Frontend Developer',
    industry: 'Finance',
    techStack: ['React', 'Typescript', 'CSS', 'Python'],
    salary: salary,
    description:
      'You will work on building reusable UI components in React. This work may be in support of new feature development...',
    color: '#057992',
    bgColor: '#DEF3F7',
  },
  {
    icon: '/images/light-lp/icons/stack.svg',
    title: 'Lead Mobile Developer',
    industry: 'Healthcare',
    techStack: ['Swift', 'Python'],
    salary: salary,
    description:
      'Provide technical leadership to mobile developers working in iOS platform, design & build advanced applications in iOS...',
    color: '#2D7B57',
    bgColor: '#D2F5E4',
  },
  {
    icon: '/images/light-lp/icons/cogs.svg',
    title: 'Backend Developer',
    industry: 'Healthcare',
    techStack: ['Python', 'HTML/CSS', 'AWS', 'Node'],
    salary: salary,
    description:
      'Apply your experience and skills to build and deploy new data workflows while playing a key role in team mentorship...',
    color: '#25383F',
    bgColor: '#F4F7F9',
  },
  {
    icon: '/images/light-lp/icons/disk.svg',
    title: 'Senior Software Developer',
    industry: 'Consumer Software',
    techStack: ['Java', 'Ruby', 'React', 'AWS', 'Typescript'],
    salary: salary,
    description:
      'You will help our teams build amazing features for millions of users while actively engaging with design...',
    color: '#7D391C',
    bgColor: '#FFF0CB',
  },
  {
    icon: '/images/light-lp/icons/stack.svg',
    title: 'Fullstack Developer',
    industry: 'Software',
    techStack: ['React', 'Ruby on Rails', 'Python', 'HTML/CSS'],
    salary: salary,
    description:
      'You will be deeply involved with the feature and technical decision making, so should be comfortable using data to drive rapid testing/iterating...',
    color: '#2D7B57',
    bgColor: '#D2F5E4',
  },
  {
    icon: '/images/light-lp/icons/cogs.svg',
    title: 'Senior DevOps Developer',
    industry: 'Retail',
    techStack: ['UNIX', 'Linux', 'Perl', 'AWS', 'Docker', 'Mongo'],
    salary: salary,
    description:
      'Help build, maintain and improve healthy cloud infrastructure, automation pipelines & infrastructure development workflows...',
    color: '#25383F',
    bgColor: '#F4F7F9',
  },
  {
    icon: '/images/light-lp/icons/disk.svg',
    title: 'Mid-Level Software Developer',
    industry: 'Business Services',
    techStack: ['Node.JS', 'Databases'],
    salary: salary,
    description:
      'Join the founding team and build the product from 0 to 1 with us. A passionate developer that loves building new and challenging...',
    color: '#7D391C',
    bgColor: '#FFF0CB',
  },
  {
    icon: '/images/light-lp/icons/stack.svg',
    title: 'Senior iOS Developer',
    industry: 'Software',
    techStack: ['Swift', 'XCode'],
    salary: salary,
    description:
      'Participate in a founding team of iOS developers on an application to be enjoyed by thousands of users worldwide and be directly responsible for mobile experience...',
    color: '#2D7B57',
    bgColor: '#D2F5E4',
  },
];
